import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import SEO from "../components/seo/SEO";

const WHATSAPP_NUMBER = "919532119007"; // 👈 replace with your real number

const NotFound = () => {
  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        background: `
          radial-gradient(circle at top, rgba(244,211,94,0.25), transparent 40%),
          linear-gradient(180deg, #ffffff, var(--color-sunshine))
        `,
      }}
    >
      <SEO
        title="Page Not Found | NearbyGuide"
        description="The page you are looking for does not exist. Explore cities and nearby places on NearbyGuide."
        noIndex
      />

      <Container maxWidth="sm">
        <Box
          sx={{
            textAlign: "center",
            p: { xs: 3, md: 4 },
            borderRadius: 3,
            backgroundColor: "#fff",
            boxShadow: "0 20px 60px rgba(13,59,102,0.15)",
          }}
        >
          {/* 404 */}
          <Typography
            sx={{
              fontSize: { xs: "4rem", md: "5rem" },
              fontWeight: 900,
              color: "var(--color-neon)",
              lineHeight: 1,
            }}
          >
            404
          </Typography>

          {/* Title */}
          <Typography
            sx={{
              fontSize: { xs: "1.4rem", md: "1.6rem" },
              fontWeight: 700,
              mt: 1,
              color: "var(--text-heading)",
            }}
          >
            Page not found
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              color: "var(--text-secondary)",
              mt: 1,
              mb: 3,
              fontSize: "0.95rem",
              lineHeight: 1.7,
            }}
          >
            The page you’re looking for doesn’t exist or may have been moved.
            Don’t worry — you can go back home or contact us for help.
          </Typography>

          {/* CTA BUTTONS */}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            justifyContent="center"
          >
            <Button
              variant="contained"
              component={Link}
              to="/"
              sx={{
                px: 3,
                backgroundColor: "var(--color-neon)",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "var(--color-neon)",
                  opacity: 0.9,
                },
              }}
            >
              🏠 Go Home
            </Button>

            <Button
              variant="outlined"
              component="a"
              href={`https://wa.me/${WHATSAPP_NUMBER}`}
              target="_blank"
              sx={{
                px: 3,
                borderColor: "var(--color-neon)",
                color: "var(--color-neon)",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "rgba(13,59,102,0.05)",
                  borderColor: "var(--color-neon)",
                },
              }}
            >
              💬 Contact Us
            </Button>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default NotFound;
